import React from "react";
import { Link } from "react-router-dom";

export class SegreggationsEvaluation extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section>
          <div
            className="bannerimg cover-image bg-background3 sptb-2"
            data-image-src="../assets/images/banners/banner2.jpg"
          >
            <div className="header-text mb-0">
              <div className="container">
                <div className="text-center text-white ">
                  <h1 className="">Segreggations & Evaluation</h1>
                  <ol className="breadcrumb text-center">
                    <li className="breadcrumb-item">
                      <Link exact="true" to="/">
                        Home
                      </Link>
                    </li>
                    <li
                      className="breadcrumb-item active text-white"
                      aria-current="page"
                    >
                      Services
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="sptb">
          <div className="container">
            <div className="text-justify mb-7">
              <h2 className="mb-8">Segreggations & Evaluation</h2>
              <p className="leading-Automatic mb-4"></p>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
